module.exports = __webpack_public_path__ + "static/index-zoom-91cb3058b56b4efd62fbfd3587a59034.jpg";